"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentAdapterIngenico = void 0;

var uuid_1 = require("uuid");

var credit_card_type_1 = __importStar(require("credit-card-type"));

var interface_adapter_1 = require("../Interfaces/interface.adapter");

var Interfaces_1 = require("../Interfaces");

var Errors_1 = require("../Errors");

var IngenicoPaymentProductId;

(function (IngenicoPaymentProductId) {
  IngenicoPaymentProductId[IngenicoPaymentProductId["ATU_CARD"] = 3004] = "ATU_CARD";
  IngenicoPaymentProductId[IngenicoPaymentProductId["ACCOR_BUSINESS_ACCOUNT"] = 3002] = "ACCOR_BUSINESS_ACCOUNT";
  IngenicoPaymentProductId[IngenicoPaymentProductId["AMERICAN_EXPRESS"] = 2] = "AMERICAN_EXPRESS";
  IngenicoPaymentProductId[IngenicoPaymentProductId["ARGENCARD"] = 140] = "ARGENCARD";
  IngenicoPaymentProductId[IngenicoPaymentProductId["AURA"] = 146] = "AURA";
  IngenicoPaymentProductId[IngenicoPaymentProductId["BANCOTACT"] = 3012] = "BANCOTACT";
  IngenicoPaymentProductId[IngenicoPaymentProductId["CABAL"] = 135] = "CABAL";
  IngenicoPaymentProductId[IngenicoPaymentProductId["CARTE_BANCAIRE"] = 130] = "CARTE_BANCAIRE";
  IngenicoPaymentProductId[IngenicoPaymentProductId["CONSUMAX"] = 141] = "CONSUMAX";
  IngenicoPaymentProductId[IngenicoPaymentProductId["DANKORT"] = 123] = "DANKORT";
  IngenicoPaymentProductId[IngenicoPaymentProductId["DINERS_CLUB"] = 132] = "DINERS_CLUB";
  IngenicoPaymentProductId[IngenicoPaymentProductId["DISCOVER"] = 128] = "DISCOVER";
  IngenicoPaymentProductId[IngenicoPaymentProductId["ELO"] = 147] = "ELO";
  IngenicoPaymentProductId[IngenicoPaymentProductId["HIPER"] = 163] = "HIPER";
  IngenicoPaymentProductId[IngenicoPaymentProductId["HIPERCARD"] = 148] = "HIPERCARD";
  IngenicoPaymentProductId[IngenicoPaymentProductId["ITALCRED"] = 139] = "ITALCRED";
  IngenicoPaymentProductId[IngenicoPaymentProductId["JCB"] = 125] = "JCB";
  IngenicoPaymentProductId[IngenicoPaymentProductId["MAESTRO"] = 117] = "MAESTRO";
  IngenicoPaymentProductId[IngenicoPaymentProductId["MAS"] = 142] = "MAS";
  IngenicoPaymentProductId[IngenicoPaymentProductId["MASTER_CARD"] = 3] = "MASTER_CARD";
  IngenicoPaymentProductId[IngenicoPaymentProductId["MASTER_CARD_DEBIT"] = 119] = "MASTER_CARD_DEBIT";
  IngenicoPaymentProductId[IngenicoPaymentProductId["MIR"] = 164] = "MIR";
  IngenicoPaymentProductId[IngenicoPaymentProductId["NARANJA"] = 136] = "NARANJA";
  IngenicoPaymentProductId[IngenicoPaymentProductId["NATIVA"] = 145] = "NATIVA";
  IngenicoPaymentProductId[IngenicoPaymentProductId["NEVADA"] = 137] = "NEVADA";
  IngenicoPaymentProductId[IngenicoPaymentProductId["PYME_NACION"] = 144] = "PYME_NACION";
  IngenicoPaymentProductId[IngenicoPaymentProductId["TARJETA_SHOPPING"] = 149] = "TARJETA_SHOPPING";
  IngenicoPaymentProductId[IngenicoPaymentProductId["UATP"] = 120] = "UATP";
  IngenicoPaymentProductId[IngenicoPaymentProductId["UNION_PAY"] = 56] = "UNION_PAY";
  IngenicoPaymentProductId[IngenicoPaymentProductId["VISA"] = 1] = "VISA";
  IngenicoPaymentProductId[IngenicoPaymentProductId["VISA_DEBIT"] = 114] = "VISA_DEBIT";
  IngenicoPaymentProductId[IngenicoPaymentProductId["VISA_ELECTRON"] = 122] = "VISA_ELECTRON";
})(IngenicoPaymentProductId || (IngenicoPaymentProductId = {}));

var PaymentAdapterIngenico =
/** @class */
function (_super) {
  __extends(PaymentAdapterIngenico, _super);

  function PaymentAdapterIngenico(env, vendorSessionInfo, billingContactInfo) {
    var _this = _super.call(this) || this;

    _this.vendorName = interface_adapter_1.PaymentVendors.ingenico;
    _this.env = env;
    _this.vendorSessionInfo = vendorSessionInfo;
    _this.billingContactInfo = billingContactInfo;

    if (typeof forge === 'undefined') {
      throw new Errors_1.PaymentClientError('Cannot find vendor module, please make sure to load it', Interfaces_1.PaymentErrorShortCodes.missing_vendor_library, {
        cause: {
          message: 'forge module not loaded'
        }
      });
    }

    return _this;
  }

  PaymentAdapterIngenico.prototype.encryptCreditCardData = function (creditCard) {
    return __awaiter(this, void 0, void 0, function () {
      var decodedSession, paymentProductId, paymentValues, ingenicoSession, joseEncryptor, encryptedCard, e_1, errorMessage;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);

            return [4
            /*yield*/
            , this.getDecodedVendorSessionPayload()];

          case 1:
            decodedSession = _a.sent();
            paymentProductId = PaymentAdapterIngenico.getIngenicoPaymentProductId(creditCard.number);
            paymentValues = [{
              key: 'cardNumber',
              value: creditCard.number
            }, {
              key: 'expiryDate',
              value: creditCard.expiration.month + creditCard.expiration.year.slice(-2)
            }, {
              key: 'cvv',
              value: creditCard.securityCode
            }];

            if (creditCard.nameOnCard) {
              paymentValues.push({
                key: 'cardholderName',
                value: creditCard.nameOnCard
              });
            }

            ingenicoSession = {
              clientSessionId: decodedSession.token.clientSessionId,
              nonce: (0, uuid_1.v4)(),
              paymentProductId: paymentProductId,
              tokenize: true,
              paymentValues: paymentValues
            };
            joseEncryptor = new JOSEEncryptor();
            return [4
            /*yield*/
            , joseEncryptor.encrypt(ingenicoSession, decodedSession.publicKey)];

          case 2:
            encryptedCard = _a.sent();
            return [2
            /*return*/
            , encryptedCard];

          case 3:
            e_1 = _a.sent();
            errorMessage = e_1.message || 'Invalid credit card number';
            throw new Errors_1.PaymentClientError('Validation Error: ' + errorMessage, Interfaces_1.PaymentErrorShortCodes.invalid_card_number_encryption_error, {
              vendorName: this.vendorName,
              cause: {
                message: e_1.message,
                details: JSON.stringify(e_1)
              },
              code: 'BG-2302'
            });

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentAdapterIngenico.prototype.encryptACHData = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        throw new Errors_1.PaymentClientError('Payment Method is not supported', Interfaces_1.PaymentErrorShortCodes.unsupported_payment_method);
      });
    });
  };

  PaymentAdapterIngenico.prototype.initializeWebDropIn = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        throw new Errors_1.PaymentClientError('Payment Method is not supported', Interfaces_1.PaymentErrorShortCodes.unsupported_payment_method);
      });
    });
  };

  PaymentAdapterIngenico.prototype.initializeWebComponent = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        throw new Errors_1.PaymentClientError('Payment Method is not supported', Interfaces_1.PaymentErrorShortCodes.unsupported_payment_method);
      });
    });
  }; // A list of Ingenico Payment Products and their corresponding IDs can be found at:
  // https://epayments-api.developer-ingenico.com/c2sapi/v1/en_US/javascript/paymentproducts.html?paymentPlatform=ALL


  PaymentAdapterIngenico.getIngenicoPaymentProductId = function (number) {
    /* Skipping the following product IDs:
      - ACCOR_BUSINESS_ACCOUNT
      - ARGENCARD
      - ATU_CARD
      - AURA
      - BANCOTACT
      - CABAL
      - CARTE_BANCAIRE
      - CONSUMAX
      - DANKORT
      - ELO
      - HIPER
      - HIPERCARD
      - ITALCRED
      - JCB
      - MAS
      - MASTER_CARD_DEBIT (covered by MASTER_CARD)
      - MIR
      - NARANJA
      - NATIVA
      - NEVADA
      - PYME_NACION
      - TARJETA_SHOPPING
      - UATP
      - UNION_PAY
      - VISA_DEBIT (covered by VISA)
      - VISA_ELECTRON (covered by VISA)
    */
    var matchedCardTypes = (0, credit_card_type_1["default"])(number);

    if (matchedCardTypes.length > 0) {
      var cardType = matchedCardTypes[0];

      switch (cardType.type) {
        case credit_card_type_1.types.AMERICAN_EXPRESS:
          return IngenicoPaymentProductId.AMERICAN_EXPRESS;

        case credit_card_type_1.types.DINERS_CLUB:
          return IngenicoPaymentProductId.DINERS_CLUB;

        case credit_card_type_1.types.DISCOVER:
          return IngenicoPaymentProductId.DISCOVER;

        case credit_card_type_1.types.MAESTRO:
          return IngenicoPaymentProductId.MAESTRO;

        case credit_card_type_1.types.MASTERCARD:
          return IngenicoPaymentProductId.MASTER_CARD;

        case credit_card_type_1.types.VISA:
          return IngenicoPaymentProductId.VISA;
      }
    } // If not matched, return on-prem mapping instead


    return PaymentAdapterIngenico.getOnPremPaymentProductId(number);
  }; // On-Prem only supports 4 payment products, so re-mapping needs to happen


  PaymentAdapterIngenico.getOnPremPaymentProductId = function (number) {
    if (number.startsWith('3')) {
      return IngenicoPaymentProductId.AMERICAN_EXPRESS;
    }

    if (number.startsWith('5')) {
      return IngenicoPaymentProductId.MASTER_CARD;
    }

    if (number.startsWith('6')) {
      return IngenicoPaymentProductId.DISCOVER;
    }

    return IngenicoPaymentProductId.VISA;
  };

  return PaymentAdapterIngenico;
}(interface_adapter_1.PaymentAdapter);

exports.PaymentAdapterIngenico = PaymentAdapterIngenico; // Use Ingenico's JOSEEncryptor to encrypt credit card data instead of using their SDK
// This class was refactored from "node_modules/connect-sdk-client-js/src/JOSEEncryptor.js" (version 3.19.1)
// The original file is also available online at:
// https://github.com/Ingenico-ePayments/connect-sdk-client-js/blob/master/src/JOSEEncryptor.js

var JOSEEncryptor =
/** @class */
function () {
  function JOSEEncryptor() {
    this.pki = forge.pki;
    this.asn1 = forge.asn1;
    this.CEKKEYLENGTH = 512;
    this.IVLENGTH = 128; // Empty
  }

  JOSEEncryptor.prototype.encrypt = function (plainTextValues, publicKeyResponse) {
    // Create protected header and encode it with Base64 encoding
    var payload = JSON.stringify(plainTextValues);
    var protectedHeader = this.createProtectedHeader(publicKeyResponse.keyId);
    var encodededProtectedHeader = this.base64UrlEncode(protectedHeader); // Create ContentEncryptionKey, is a random byte[]

    var CEK = forge.random.getBytesSync(this.CEKKEYLENGTH / 8);
    var publicKey = this.decodePemPublicKey(publicKeyResponse.publicKey); // Encrypt the contentEncryptionKey with the GC gateway publickey and encode it with Base64 encoding

    var encryptedContentEncryptionKey = this.encryptContentEncryptionKey(CEK, publicKey);
    var encodedEncryptedContentEncryptionKey = this.base64UrlEncode(encryptedContentEncryptionKey); // Split the contentEncryptionKey in ENC_KEY and MAC_KEY for using hmac

    var macKey = CEK.substring(0, this.CEKKEYLENGTH / 2 / 8);
    var encKey = CEK.substring(this.CEKKEYLENGTH / 2 / 8); // Create Initialization Vector

    var initializationVector = forge.random.getBytesSync(this.IVLENGTH / 8);
    var encodededinitializationVector = this.base64UrlEncode(initializationVector); // Encrypt content with ContentEncryptionKey and Initialization Vector

    var cipherText = this.encryptPayload(payload, encKey, initializationVector);
    var encodedCipherText = this.base64UrlEncode(cipherText); // Create Additional Authenticated Data  and Additional Authenticated Data Length

    var al = this.calculateAdditionalAuthenticatedDataLength(encodededProtectedHeader); // Calculates HMAC

    var calculatedHmac = this.calculateHMAC(macKey, encodededProtectedHeader, initializationVector, cipherText, al); // Truncate HMAC Value to Create Authentication Tag

    var authenticationTag = calculatedHmac.substring(0, calculatedHmac.length / 2);
    var encodedAuthenticationTag = this.base64UrlEncode(authenticationTag);
    return encodededProtectedHeader + '.' + encodedEncryptedContentEncryptionKey + '.' + encodededinitializationVector + '.' + encodedCipherText + '.' + encodedAuthenticationTag;
  };

  JOSEEncryptor.prototype.base64UrlEncode = function (str) {
    str = forge.util.encode64(str);
    str = str.split('=')[0];
    str = str.replace(/\+/g, '-');
    str = str.replace(/\//g, '_');
    return str;
  };

  JOSEEncryptor.prototype.createProtectedHeader = function (kid) {
    var JOSEHeader = {
      alg: 'RSA-OAEP',
      enc: 'A256CBC-HS512',
      kid: kid
    };
    return JSON.stringify(JOSEHeader);
  };

  JOSEEncryptor.prototype.decodePemPublicKey = function (publickeyB64Encoded) {
    // step 1: base64decode
    var publickeyB64Decoded = forge.util.decode64(publickeyB64Encoded); // create a bytebuffer with these bytes

    var buffer2 = forge.util.createBuffer(publickeyB64Decoded, 'raw'); // convert DER to ASN1 object

    var publickeyObject2 = forge.asn1.fromDer(buffer2); // convert to publicKey object

    var publicKey2 = this.pki.publicKeyFromAsn1(publickeyObject2);
    return publicKey2;
  };

  JOSEEncryptor.prototype.encryptContentEncryptionKey = function (CEK, publicKey) {
    // encrypt CEK with OAEP+SHA-1+MGF1Padding
    var encryptedCEK = publicKey.encrypt(CEK, 'RSA-OAEP');
    return encryptedCEK;
  };

  JOSEEncryptor.prototype.encryptPayload = function (payload, encKey, initializationVector) {
    var cipher = forge.cipher.createCipher('AES-CBC', encKey);
    cipher.start({
      iv: initializationVector
    });
    cipher.update(forge.util.createBuffer(payload));
    cipher.finish();
    return cipher.output.bytes();
  };

  JOSEEncryptor.prototype.calculateAdditionalAuthenticatedDataLength = function (encodededProtectedHeader) {
    var buffer = forge.util.createBuffer(encodededProtectedHeader);
    var lengthInBits = buffer.length() * 8;
    var buffer2 = forge.util.createBuffer(); // convert int to 64bit big endian

    buffer2.putInt32(0);
    buffer2.putInt32(lengthInBits);
    return buffer2.bytes();
  };

  JOSEEncryptor.prototype.calculateHMAC = function (macKey, encodededProtectedHeader, initializationVector, cipherText, al) {
    var buffer = forge.util.createBuffer();
    buffer.putBytes(encodededProtectedHeader);
    buffer.putBytes(initializationVector);
    buffer.putBytes(cipherText);
    buffer.putBytes(al);
    var hmacInput = buffer.bytes();
    var hmac = forge.hmac.create();
    hmac.start(forge.sha512.create(), macKey);
    hmac.update(hmacInput);
    return hmac.digest().bytes();
  };

  return JOSEEncryptor;
}();